(function(){
    let Accordion = function(el) {
        this.el = el;
        this.trigger = el.querySelector('.js-footer-mobile-accordion-trigger');
        this.nav = el.querySelector('.js-footer-mobile-accordion-menu');
        this.active = false;
        
        this.setActiveState();
        this.bindEvents()
        
        
    }
    Accordion.prototype.bindEvents = function() {
        let that = this;
        window.addEventListener('resize', function(){
            that.setActiveState();
        });
        this.trigger.addEventListener('click', function(){
            that.toggleActive();
        });
    }
    Accordion.prototype.toggleActive = function() {
        if(this.nav.classList.contains('active')){
            this.nav.classList.remove('active');
            this.trigger.classList.remove('active');
            this.trigger.setAttribute('aria-expanded', 'false');
            this.nav.setAttribute('hidden', 'true');
        } else {
            this.nav.classList.add('active');
            this.trigger.classList.add('active');
            this.trigger.setAttribute('aria-expanded', 'true');
            this.nav.removeAttribute('hidden');
            
        }
        
    }
    Accordion.prototype.setActiveState = function() {
        // let width = window.width;
        let active = window.innerWidth < 768;
        this.active = active;
        
        if(active) {
            this.renderAsActive();
        } else {
            this.renderAsInactive();
            
        }
    }
    Accordion.prototype.renderAsActive = function() {
        
        this.el.classList.add('is-accordion');
        this.nav.setAttribute('hidden','true');
        this.trigger.removeAttribute('aria-expanded');
        this.trigger.removeAttribute('hidden', 'true');
        
        // this.nav.classList.add('active');
    }
    Accordion.prototype.renderAsInactive = function() {
        
        this.trigger.setAttribute('hidden', 'true');
        this.el.classList.remove('is-accordion');
        this.nav.removeAttribute('hidden');
        // this.nav.classList.remove('active');
    }
    let footer_accordions = document.querySelectorAll('.js-footer-mobile-accordion');
    for (var i=0; i<footer_accordions.length; i++) {
            if(footer_accordions[i].getElementsByClassName('js-footer-mobile-accordion-menu').length > 0) {
                new Accordion(footer_accordions[i]);
            }
            
        
        
    }
})();